<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content report-box  container-fluid">
      <!-- Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <breadcrumbthree :title="title" :text="text" :text1="text1" />
        </div>
      </div>

      <form 
        class="mb-4" 
        @submit.prevent="
        updateSection(
        section_one.page,
        section_one.section,
        section_one.language,
        section_one)"
      >
        <div class="page-header subscribe-head">
          <div class="row align-items-center">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Título:</label>
                <input 
                type="text" 
                class="form-control" 
                v-model="section_one.title"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="col-auto" style="float:right">
                <button type="submit" class="btn btn-primary">
                  <i class="fas fa-save"></i> Guardar </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">
            <div class="form-group">
              <label>Párrafo Principal</label>
              <textarea
              class="form-control"
              name="txt-quienessomos"
              placeholder=""
              style="min-height:270px"
              v-model="section_one.text"
              >
              </textarea>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Url Video</label>
              <input 
              type="text" 
              class="form-control" 
              v-model="section_one.video"
              />
            </div>
            <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
              <iframe 
                :src="section_one.video" 
                frameborder="0" 
                allow="autoplay; picture-in-picture; clipboard-write;" 
                style="position:absolute;top:0;left:0;width:100%;height:100%;
              ">
              </iframe>
            </div>
          </div>
        </div>
      </form>


      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Experiencias</span>
            <div class="col-auto" style="float:right">
              <a
                  class="btn add-user"
                  href="javascript:;"
                  data-bs-toggle="modal"
                  data-bs-target="#add_experience"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                      type="search"
                      class="form-control form-control-sm ms-2"
                      placeholder=""
                      aria-controls="DataTables_Table_0"
                      v-model = "searched_experience"
                      @input="localSearch()"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                    class="stripped table-hover"
                    :columns="columnsTableExperience"
                    :data-source="dataTableFiltExperience"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'title'">
                      <div>{{ record.title }}</div>
                    </template>
                    <template v-if="column.key === 'description'">
                      <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-secondary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#add_experience"
                            @click="loadEditModalExperience(record)"
                        ><i class="far fa-edit"></i
                        ></a>
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_experience"
                            @click="loadDeleteModalExperience(record)"
                        ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Testimonios</span>
            <div class="col-auto" style="float:right">
              <a
                  class="btn add-user"
                  href="javascript:;"
                  data-bs-toggle="modal"
                  data-bs-target="#add_testimonials"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                      type="search"
                      class="form-control form-control-sm ms-2"
                      placeholder=""
                      aria-controls="DataTables_Table_0"
                      v-model = "searched_testimonials"
                      @input="localSearchTestimonials()"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                    class="stripped table-hover"
                    :columns="columnsTableTestimonials"
                    :data-source="dataTableFiltTestimonials"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'title'">
                      <div>{{ record.title }}</div>
                    </template>
                    <template v-if="column.key === 'description'">
                      <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-secondary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#add_testimonials"
                            @click="loadEditModalTestimonial(record)"
                        ><i class="far fa-edit"></i
                        ></a>
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_experience"
                            @click="loadDeleteModalExperience(record)"
                        ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- /Page Wrapper -->

  <!-- The Modal -->
  <div class="modal fade custom-modal" id="add-nuestrosgraduados">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Rótulo</label>
              <input class="form-control" name="txt-rotulo"  placeholder="Rótulo" />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input type="file" class="form-control" name="txt-imagen" accept="image/png, image/gif, image/jpeg"/>
              <div class="ver-imagen"> </div>
            </div>
            <div class="form-group">
              <label>Link</label>
              <input type="text" class="form-control" name="txt-link"/>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-primary btn-block">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /The Modal -->

  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit-nuestrosgraduados">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">

         <form>
            <div class="form-group">
              <label>Rótulo</label>
              <input class="form-control" name="txt-rotulo"  placeholder="Rótulo" />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input type="file" class="form-control" name="txt-imagen" accept="image/png, image/gif, image/jpeg"/>
              <div class="ver-imagen">
                <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                <img src="@/assets/img/escuela_corp1.jpg"/>
              </div>
            </div>
            <div class="form-group">
              <label>Link</label>
              <input type="text" class="form-control" name="txt-link"/>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-primary btn-block">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->

  <!--Delete modal-->
  <div class="modal custom-modal fade" id="delete_experience" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteExperience"
                >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                    href="javascript:void(0);"
                    data-bs-dismiss="modal"
                    class="btn btn-agv-dos cancel-btn"
                >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal-->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_experience">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Guardar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addExperience">
            <div class="form-group">
              <label>Experiencia</label>
              <textarea
                  class="form-control"
                  name="txt-descripcion"
                  required
                  v-model="experience_text">
                    </textarea>
            </div>
            <div class="form-group">
              <label>URL Video</label>
              <input
                  type="text"
                  class="form-control"
                  name="txt-video"
                  required
                  v-model="video_experience"
              />
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_testimonials">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Guardar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addTestimonial">
            <div class="form-group">
              <label>Trabajador</label>
              <input
                  type="text"
                  class="form-control"
                  name="name-worker"
                  required
                  v-model="name_worker_testimonial"/>
            </div>
            <div class="form-group">
              <label>Cargo</label>
              <input
                  type="text"
                  class="form-control"
                  name="post-worker"
                  required
                  v-model="work_pos_testimonial"/>
            </div>
            <div class="form-group">
              <label>Testimonio</label>
              <textarea
                  class="form-control"
                  name="txt-descripcion"
                  required
                  v-model="testimonials_text">
                    </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input
                  type="file"
                  class="form-control"
                  name="txt-imagen"
                  accept="image/png, image/gif, image/jpeg"
                  @change="handlePhotoChangeTestimonial"
              />
              <div class="img-preview">
                <img :src="img_preview_testimonial"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->
</template>

<style>

    .ver-video{
        max-width: 100%;
        position: relative;
    }

    .ver-video video{
      width: 100%;
    }

    .ver-imagen{
        padding: 6px;
        width: 100%;
        position: relative;
    }

    .ver-imagen button, .ver-video button {
        position: absolute;
        right: 16px;
        top: 16px;
    }
</style>

<script>

const baseCols = [
    { title: "Actions", dataIndex: "id", class: "text-end"},
    { title: "N°", dataIndex: "index"},
    { title: "Rótulo", dataIndex: "rotulo"},
    { title: "Imagen", dataIndex: "imagenUrl"},
];

const columns = baseCols.map ( column => {
    return {
        title: column.title,
        dataIndex: column.dataIndex,
        key: column.dataIndex,
        sorter : false,
        class: column?.class ?? "" ,
    }
});

import axiosIns from '@/plugins/axios.js';

import data from "./data.json";
import { ref } from "vue";
const currentDate = ref(new Date());
import { router } from "@/router";

const fnbaseToCols = (column) => {
  return {
    title: column.title,
    dataIndex: column.dataIndex,
    key: column.dataIndex,
    sorter : false,
    class: column?.class ?? "" ,
  }
};

const baseColsTableExperience = [
  { title: "Experiencia", dataIndex: "experience"},
  { title: "Video", dataIndex: "video"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableExperience = baseColsTableExperience.map ( fnbaseToCols );

const baseColsTableTestimonials = [
  { title: "Trabajador", dataIndex: "name"},
  { title: "Cargo", dataIndex: "position"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableTestimonials = baseColsTableTestimonials.map ( fnbaseToCols );

export default {
  data() {
    return {
      columnsTableExperience,
      columnsTableTestimonials,
      columns,
      data,
      title: "Escuela Corporativa",
      text: "Mantenimientos Páginas",
      text1: "Escuela Corporativa",
      filterInputsDisplay: "none",
      startdate: currentDate,

      section_one:[],
      img_section_one: null,
      img_preview_section_one: null,
      section_two:[],
      img_preview_section_two_first:null,
      img_preview_section_two_second:null,

      img_section_two_first:null,
      img_section_two_second:null,

      language:null,
      dialogLoading: false,

      dataTableExperience: [],
      searched_experience: null,
      dataTableFiltExperience:[],
      experience_text: null,
      video_experience: null,
      img_experience: null,
      img_preview_experience: null,
      id_experience: 0,

      dataTableTestimonials: [],
      searched_testimonials: null,
      dataTableFiltTestimonials: [],
      name_worker_testimonial: null,
      work_pos_testimonial: null,
      testimonials_text: null,
      img_testimonial: null,
      img_preview_testimonial: null,
      id_testimonial: 0,

    };
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userDataAdmin')) {
      router.push('/admin/login');
    }else{
      next()
    }
  },
  mounted(){
    this.getPageData()
    this.getTestimonials()
  },
  methods: {

    clearValuesExperience(){
      this.experience_text = ''
      this.img_experience = null
      this.video_experience = ''
      this.id_experience = 0
    },

    clearValuesTestimonial(){
      this.name_worker_testimonial = ''
      this.work_pos_testimonial = ''
      this.testimonials_text = ''
      this.img_testimonial = null
      this.id_testimonial = 0
    },

    loadEditModalExperience(data){
      // console.log("Información encontrada", data)
      this.experience_text = data.content
      this.video_experience = data.video
      this.id_experience = data.id
    },

    loadDeleteModalExperience(datos){
      this.id_experience = datos.id
    },

    deleteExperience(){
      const yo = this
      const config = {
        method: 'post',
        url: '/talentoagv/deleteExperience/',
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // },
        data: {
          idcontent: this.id_experience
        },
      }
      yo.dialogLoading = true
      axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.getPageData()
              // yo.clearValuesExperience()
              yo.$toastr.success(response.data['message'], 'Éxito')
            }
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toastr.error("Error consulte con su Administrador", 'Error')
            yo.dialogLoading = false
          })
          .finally(function (){

          })
    },

    loadEditModalTestimonial(data){
      console.log("información encontrada", data)
      this.name_worker_testimonial = data.name
      this.work_pos_testimonial = data.position
      this.testimonials_text = data.text
      this.img_preview_testimonial = data.s3_url
      this.id_testimonial = data.id
    },

    addTestimonial(){
      const yo = this
      const formData = new FormData();
      formData.append('name_testimonial', yo.name_worker_testimonial);
      formData.append('work_pos_testimonial', yo.work_pos_testimonial);
      formData.append('text_testimonial', yo.testimonials_text);
      formData.append('img_testimonial', yo.img_testimonial);
      formData.append('language', yo.language);
      formData.append('pagina', '4');
      formData.append('seccion', '9');
      formData.append('id_testimonial', yo.id_testimonial)

      const config = {
        method: 'post',
        url: '/talentoagv/createTestimonial/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      yo.dialogLoading = true

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.getTestimonials()
              yo.clearValuesTestimonial()
              yo.$toastr.success(response.data['message'], 'Éxito')
              yo.dialogLoading = true
            }
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
            yo.dialogLoading = false
          })
          .finally(function (){

          })
    },

    getTestimonials(){
      const yo = this
      yo.dataTableTestimonials = []
      yo.dataTableFiltTestimonials = []
      const data = JSON.stringify({
        pagina : '4',
        seccion : '9',
      })
      yo.dialogLoading = true
      const config = {
        method: 'post',
        url: '/talentoagv/readTestimonials/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data,
      }

      axiosIns(config)
          .then(function (response) {
            // console.log(response.data['result'])
            if (response.data['is_error'] === false){
              let resultado = response.data['result']
              // console.log("la informacion obtenida de los testimonios",resultado)
              // console.log(yo.language)
              for(let r of resultado){
                // console.log(r)
                if(r['key_idioma_id'] == yo.language){
                  yo.dataTableTestimonials.push(r)
                  yo.dataTableFiltTestimonials.push(r)
                }
              }
              // yo.dataTableTestimonials = response.data['result']
              // yo.dataTableFiltTestimonials = response.data['result']
            }
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toastr.error("Error consulte con su administrador.", 'Error')
          })
          .finally(function (){
            yo.dialogLoading = false
          })
    },

    addExperience(){
      const yo = this
      const formData = new FormData();
      // formData.append('name_testimonial', yo.name_testimonial);
      // formData.append('work_pos_testimonial', yo.work_pos_testimonial);
      formData.append('experience_text', yo.experience_text);
      formData.append('img_experience', yo.img_experience);
      formData.append('video_experience', yo.video_experience);
      formData.append('language', yo.language);
      formData.append('idpage', '4');
      formData.append('section', 'dos');
      formData.append('id_experience', yo.id_experience)

      const config = {
        method: 'post',
        url: '/talentoagv/createExperience/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      yo.dialogLoading = true

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.getPageData()
              yo.clearValuesExperience()
              yo.$toastr.success(response.data['message'], 'Éxito')
            }
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
            yo.dialogLoading = false
          })
          .finally(function (){

          })
    },

    handlePhotoChangeTestimonial(event){
      const file = event.target.files[0];
      if (file) {
        this.img_testimonial = file;
        this.img_preview_testimonial = URL.createObjectURL(file);
      }
    },

    getPageData(){
      const yo = this
      const config = {
        method: 'get',
        url: '/talentoagv/getMainPageData/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }
      yo.dialogLoading = true

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            let experiences = []
            for(let r of resultado){
              if(r['idlanguage'] == yo.language){
                if(r['section'] == 'uno' && r['idpage'] == '4'){
                  yo.section_one = r
                  console.log("primera seccion de escula corporativa",yo.section_one)
                }else if(r['section'] == 'dos' && r['idpage'] == '4'){
                  // yo.section_two = r
                  experiences.push({ experience: r.text.substring(0,50)+"...", content: r.text, video: r.video, id: r.idcontent })
                }
              }
            }
            yo.dataTableFiltExperience = experiences
            yo.dataTableExperience = experiences
          }
        })
        .catch(function (error) {
          // console.log(error);
          yo.$toastr.error("Error consulte con su administrador", 'Error')
        })
        .finally(function (){
          yo.dialogLoading = false
        })
    },

    handlePhotoChangeExperience(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_experience = file;
        this.img_preview_experience = URL.createObjectURL(file);
      }
    },

    handlePhotoChangeSection(event, inputId) {
      const file = event.target.files[0];
      if (file) {
        if (inputId === 'section_two_first') {
          this.img_section_two_first = file;
          this.img_preview_section_two_first = URL.createObjectURL(file);
        } 
        else if (inputId === 'section_two_second') {
          this.img_section_two_second = file;
          this.img_preview_section_two_second = URL.createObjectURL(file);
        } 
      }
    },

    updateSection(page, section, language, content){
      const yo = this
      const formData = new FormData();

      formData.append('page', page);
      formData.append('section', section);
      formData.append('language', yo.language);
      formData.append('photo', yo.img_section_two_first);
      formData.append('photo_two', yo.img_section_two_second);
      formData.append('content', JSON.stringify(content));

      const config = {
        method: 'post',
        url: '/talentoagv/updateSection/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          yo.$toastr.success(response.data['message'], 'Éxito')
          yo.getPageData()
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){

        })
    },
    //-------------- Busqueda Local en Tabla --------------//

    localSearch(){
      const yo = this
      let data = yo.dataTableExperience
      let searched_value = yo.searched_experience.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []

      // Recorrer cada objeto en la lista de datos
      for (let obj of data) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        yo.dataTableFiltExperience = resultados
      }else{
        yo.dataTableFiltExperience = yo.dataTableExperience
      }
    },

    localSearchTestimonials(){
      const yo = this
      let data = yo.dataTableTestimonials
      let searched_value = yo.searched_experience.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []

      // Recorrer cada objeto en la lista de datos
      for (let obj of data) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        yo.dataTableFiltTestimonials = resultados
      }else{
        yo.dataTableFiltTestimonials = yo.dataTableTestimonials
      }
    },
  },
};
</script>
